import { jsx, jsxs } from "react/jsx-runtime";
import react, { memo } from "react";
import { ChildAgeSelect } from "./ChildAgeSelect.js";
import { TravelerLineItem } from "./TravelerLineItem.js";
const ChildrenLineItem = ({ ages, ageSelectEnabled, count, max, isHotel, onAgeChange, onChange, subLabel })=>{
    const selects = Array.from({
        length: count ?? 0
    }, (_, childNumber)=>childNumber);
    const sublabel = ageSelectEnabled ? void 0 : subLabel;
    return /*#__PURE__*/ jsxs("div", {
        className: "flex w-full flex-col",
        children: [
            /*#__PURE__*/ jsx(TravelerLineItem, {
                label: "Children",
                subLabel: sublabel,
                min: 0,
                max: max,
                count: count,
                onChange: onChange
            }),
            ageSelectEnabled ? selects.map((childNumber)=>/*#__PURE__*/ jsx(react.Fragment, {
                    children: /*#__PURE__*/ jsx(ChildAgeSelect, {
                        index: childNumber,
                        isHotel: isHotel,
                        value: ages?.[childNumber],
                        onChange: onAgeChange
                    })
                }, `container-${childNumber}`)) : null
        ]
    });
};
var TravelerLineItems_ChildrenLineItem = /*#__PURE__*/ memo(ChildrenLineItem);
export default TravelerLineItems_ChildrenLineItem;
